const emptyCredential = {
  authentication: null,
  token: null,
  refreshToken: null,
  missingConsents: null
};
export {
  emptyCredential
};
